import gql from 'graphql-tag';
import { DEAL_CALL_ACTIVITY_FRAGMENT } from './fragments/dealCallActivity.fragment';
import { DEAL_NOTE_ACTIVITY_FRAGMENT } from './fragments/dealNoteActivity.fragment';
import { DEAL_EVENT_ACTIVITY_FRAGMENT } from './fragments/dealEventActivity.fragment';

export const UPDATE_DEAL_ACTIVITY = gql`
  mutation UpdateDealActivity($input: UpdateDealActivityInput!) {
    dealActivity {
      result: updateDealActivity(input: $input) {
        error
        success
        entity {
          __typename
          ...DealCallActivityFields
          ...DealNoteActivityFields
          ...DealEventActivityFields
        }
      }
    }
  }
  ${DEAL_CALL_ACTIVITY_FRAGMENT}
  ${DEAL_NOTE_ACTIVITY_FRAGMENT}
  ${DEAL_EVENT_ACTIVITY_FRAGMENT}
`;
